import { Button } from "@/components/ui/button"
import { Separator } from "@/components/ui/separator"
import { SidebarTrigger } from "@/components/ui/sidebar"
import { usePathname } from 'next/navigation';

const urls = {
  "/auth/polis":"Полисы",
  "/auth/obrs":"Обращения",
  "/auth/obrs/obrCard":"Обращение"
}



export function SiteHeader() {
  var vis
  const pathname = usePathname()

  for (var key in urls) {
    if (key == pathname) {
      vis = urls[key]
    }
  }

  return (
    <header className="flex h-(--header-height) shrink-0 items-center gap-2 border-b transition-[width,height] ease-linear group-has-data-[collapsible=icon]/sidebar-wrapper:h-(--header-height)">
      <div className="flex w-full items-center gap-1 px-4 lg:gap-2 lg:px-6">
        <SidebarTrigger className="-ml-1" />
        <Separator
          orientation="vertical"
          className="mx-2 data-[orientation=vertical]:h-4"
        />
        <h1 className="text-base font-medium">{vis}</h1>
        <div className="ml-auto flex items-center gap-2">
        </div>
      </div>
    </header>
  )
}
